export enum OrderPage {
  START = '',
  SEAT_PICKER = '/platsval',
  DETAILS = '/detaljer',
  PAYMENT = '/betalning',
  CONFIRMATION = '/bekraftelse',
  DENIED = '/felmeddelande',
};

export enum DeliveryCode {
  E_TICKET = 'H',
  TEXT_MESSAGE = 'SMS',
  PICK_UP = 'O',
  POSTCARD_STANDARD = 'M',
  POSTCARD_REK = 'G',
};

export enum PaymentStatus {
  PAID = 'Paid',
  SENT_TO_PAYMENT_SYSTEM = 'SendToPaymentSystem',
  DENIED = 'Denyed',
  ERROR = 'Error',
  PAYMENT_ERROR = 'PaymentError',
};



// WEBPACK FOOTER //
// ./src/store/Order/enums.tsx